import React, { useEffect, useState } from "react";
import { getData, putData } from "../../../services/library";
import {
  Typography,
  Box,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Modal,
  InputAdornment,
} from "@mui/material";
import Notify from "../../Notify";
import moment from "moment";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

export default function Modalobservaciones(props) {
  const [datos, setdatos] = useState(props.datos);
  const [observaciones, setObservaciones] = useState(null);
  const [almacenarobservaciones, setalmacenarobservaciones] = useState({
    id_pedidos: datos.id,
    observaciones: "",
    usuario: localStorage.getItem("user"),
    monto: "", //cambio asignado por mica hecho por guille a, abrazo
  });
  const [detalles, setDetalles] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [existeMonto, setexisteMonto] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [disBtn, setDisBtn] = useState(false);

  const obtenerObservacionesPedidos = () => {
    getData("/gestion/" + datos.id, setObservaciones);
  };

  const obtenerdetalles = async () => {
    getData(
      "/pedidos/detalle/" + datos.id_cliente + "/" + datos.id,
      setDetalles
    );
  };

  //tarea  observaciones - Al guardar o ante un error, no se muestra ningún mensaje que notifique al usuario.
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // 'success' | 'error'

  useEffect(() => {
    obtenerObservacionesPedidos();
  }, []);

  useEffect(() => {
    obtenerdetalles();
  }, [datos]);

  useEffect(() => {
    setDisBtn(!esFormularioValido());
  }, [almacenarobservaciones]);

  useEffect(() => {
    if (observaciones && observaciones.length > 0) {
      const hayMonto = observaciones.some((o) => o.monto);
      setexisteMonto(hayMonto);
    } else {
      setexisteMonto(false);
    }
  }, [observaciones]);

  const handleAbrirModal = () => setOpenModal(true);
  const handleCerrarModal = () => setOpenModal(false);

  //guardar la observacion del pedido
  const handleGuardarObservacion = async (e) => {
    e.preventDefault();
    setDisBtn(true);

    if (!esFormularioValido()) {
      setSnackbarSeverity("error");
      setSnackbarMessage(
        "Debe completar al menos Observaciones o un Monto válido."
      );
      setOpenSnackbar(true);
      setDisBtn(false); // Reactivar el botón
      return;
    }

    const montoFormateado =
      almacenarobservaciones.monto !== ""
        ? Number(
          almacenarobservaciones.monto.toString().replace(",", ".")
        ).toFixed(2)
        : null;

    try {
      const res = await fetch(UrlApi + "/gestion", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          observaciones: almacenarobservaciones.observaciones,
          usuario: localStorage.getItem("user"),
          id_pedidos: datos.id,
          monto: montoFormateado,
        }),
      });

      const data = await res.json();

      if (data.message === "OK") {
        setSnackbarSeverity("success");
        setSnackbarMessage("Observación guardada con éxito.");
        setOpenSnackbar(true);
        //limpio los campos despues
        setalmacenarobservaciones({
          observaciones: "",
          monto: ""
        });
      } else {
        throw new Error("Error inesperado en el servidor");
      }
    } catch (error) {
      setSnackbarSeverity("error");
      setSnackbarMessage("Error al guardar la observación.");
      setOpenSnackbar(true);
    } finally {
      setDisBtn(false);
    }

    obtenerObservacionesPedidos();
    logEventos(
      "Guardar observaciones para pedidos",
      "Gestion cta cte",
      "Gestion cta cte",
      localStorage.getItem("user")
    );
  };

  const esFormularioValido = () => {
    const observacion = almacenarobservaciones.observaciones?.trim();
    const monto = almacenarobservaciones.monto;

    const montoValido = isValidMonto(monto);

    return (observacion && observacion !== "") || montoValido;
  };

  const isValidMonto = (monto) => {
    if (!monto) return false;
    const valor = monto.toString().replace(",", ".");
    const regex = /^[0-9]+([.,][0-9]{1,2})?$/; // Hasta 2 decimales
    return regex.test(monto) && !isNaN(Number(valor));
  };

  // const handleCambiarEstado = (e) => {
  //   if (!existeMonto) {
  //     alert("Es necesario ingresar el monto que debe abonar el cliente en el campo correspondiente para poder aprobar el pedido.")
  //   } else {
  //     if (almacenarobservaciones.monto) {
  //       handleGuardarObservacion(e)
  //     }
  //     const date = moment().format("YYYY-MM-DD HH:mm:ss");
  //     putData(
  //       e,
  //       "/pedidos/" + datos.id,
  //       {
  //         id_estado: 21,
  //         kgacargar_original: datos.kgacargar,
  //         usuario_autoriza: localStorage.getItem("user"),
  //         fecha_hora_autoriza: date,
  //       },
  //       setNotificacion,
  //       logEventos(
  //         "Cambiar de estado de pedidos",
  //         "Gestion cta cte ",
  //         "Gestion cta cte",
  //         localStorage.getItem("user")
  //       )
  //     );
  //   }

  // };

  const handleMatienePrecioAprobar = (e) => {
    const date = moment().format("YYYY-MM-DD HH:mm:ss");
    putData(
      e,
      "/pedidos/" + datos.id,
      {
        mantiene_precio: 1,
        usuario_autoriza: localStorage.getItem("user"),
        id_estado: 21,
        fecha_hora_autoriza: date,
      },
      setNotificacion,
      logEventos(
        "Cambiar de estado de pedidos",
        "Gestion cta cte ",
        "Gestion cta cte",
        localStorage.getItem("user")
      )
    );
  };

  const handleNoMantieneyAprobar = (e) => {
    const date = moment().format("YYYY-MM-DD HH:mm:ss");

    putData(
      e,
      "/pedidos/" + datos.id,
      {
        mantiene_precio: 0,
        usuario_autoriza: localStorage.getItem("user"),
        id_estado: 21,
        fecha_hora_autoriza: date,
      },
      setNotificacion,
      logEventos(
        "Cambiar de estado de pedidos",
        "Gestion cta cte ",
        "Gestion cta cte",
        localStorage.getItem("user")
      )
    );
  };

  const handlePendiente = (e) => {
    putData(
      e,
      "/pedidos/" + datos.id,
      {
        id_estado: 19,
        kgacargar_original: datos.kgacargar,
        // usuario_autoriza:
      },
      setNotificacion,
      logEventos(
        "Cambiar de estado de pedidos de 21 a 19",
        "Gestion cta cte ",
        "Gestion cta cte",
        localStorage.getItem("user")
      )
    );
  };

  const handleClose = () => {
    props.open(false);
  };

  // //para el onchange
  const almacenar = (e) => {
    setalmacenarobservaciones({
      ...almacenarobservaciones,
      [e.target.name]: e.target.value ? e.target.value : null,
    });
  };

  const handleCambiarEstado = async (e) => {
    e.preventDefault();

    if (datos.id_condicionpago === 21) {
      // console.log("entro al if condicion de pago");

      if (!existeMonto && !almacenarobservaciones.monto) {
        // console.log("entro al if de no existe monto y no existe almacenar observaciones.monto");
        alert(
          "Es necesario ingresar el monto que debe abonar el cliente en el campo correspondiente para poder aprobar el pedido."
        );
        return; // detener la ejecución
      }

      // Si hay un monto cargado en el form, primero guardamos observación
      if (almacenarobservaciones.monto && !existeMonto) {
        // console.log("entro al if de guardar observación");
        await handleGuardarObservacion(e);
      }
    }

    // 👇 PutData se ejecuta siempre después de pasar la validación
    const date = moment().format("YYYY-MM-DD HH:mm:ss");

    putData(
      e,
      `/pedidos/${datos.id}`,
      {
        id_estado: 21,
        kgacargar_original: datos.kgacargar,
        usuario_autoriza: localStorage.getItem("user"),
        fecha_hora_autoriza: date,
      },
      setNotificacion,
      logEventos(
        "Cambiar de estado de pedidos",
        "Gestion cta cte",
        "Gestion cta cte",
        localStorage.getItem("user")
      )
    );
  };

  return (
    <Dialog open={props.open} onClose={handleClose} fullWidth maxWidth="lg">
      <Box backgroundColor={"#1F618D"}>
        <DialogTitle>
          <Typography variant="h5" align="center" color="#ffffff">
            Gestión cuenta corriente pedido nro: {datos.id}
          </Typography>
        </DialogTitle>
      </Box>

      <DialogContent
        sx={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Grid container spacing={2} sx={{ height: "100%" }}>
          <Grid item xs={6}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <Box mb={2}>
                  <Typography variant="h6" color="primary">
                    Información del Cliente
                  </Typography>
                  <Typography variant="body1">
                    <strong>{datos.cliente}</strong>
                  </Typography>
                  <Typography variant="body1">
                    Producto: <strong>{datos.nombre_producto}</strong>
                  </Typography>
                  <Typography variant="body1">
                    Cantidad: <strong>{datos.kgacargar} kg</strong>
                  </Typography>
                  <Typography variant="body1">
                    Dirección de entrega:{" "}
                    <strong>
                      {datos.direccion} {`(${datos.lugar})`}
                    </strong>
                  </Typography>
                  {datos.observaciones ? (
                    <Typography variant="body1">
                      Observaciones: <strong>{datos.observaciones}</strong>
                    </Typography>
                  ) : null}

                  {datos.id_condicionpago === 2 || datos.mantiene_precio ? (
                    <Typography variant="body1">
                      <strong>Pedido con pago anticipado </strong>
                    </Typography>
                  ) : null}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6" color="primary" mb={1}>
                  Detalles de Pedidos
                </Typography>
                <Grid container spacing={2}>
                  {detalles && detalles.length > 0 ? (
                    detalles.map((row) => (
                      <Grid item xs={12} sm={6} key={row.id} mb={1}>
                        <Box p={2} border="1px solid #ccc" borderRadius={2}>
                          <Typography variant="body1">
                            Pedido Nro: <strong>{row.id}</strong>
                          </Typography>
                          <Typography variant="body1">
                            Dirección: <strong>{row.nombre_direccion}</strong>
                          </Typography>
                          <Typography variant="body1">
                            Kg a cargar: <strong>{row.kgacargar}</strong>
                          </Typography>
                          <Typography variant="body1">
                            Estado: <strong>{row.valor}</strong>
                          </Typography>
                        </Box>
                      </Grid>
                    ))
                  ) : (
                    <Box pl={2} pt={1}>
                      <Typography variant="body2" color="textSecondary">
                        No tiene otros pedidos pendientes.
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={6}>
            <Box p={2} style={{ maxHeight: "200px", overflowY: "auto" }}>
              <Typography variant="h6" gutterBottom>
                Observaciones
              </Typography>
              {observaciones && observaciones.length > 0 ? (
                [...observaciones]
                  .sort((a, b) => b.id - a.id) //- Las observaciones deben ordenarse desde la más reciente a la más antigua. tarea
                  .map((row) => (
                    <Box
                      key={row.id}
                      mb={1}
                      p={1}
                      style={{ border: "1px solid #ccc", borderRadius: 5 }}
                    >
                      <Typography variant="body2" color="textSecondary">
                        {moment(row.created_at).format("DD-MM-YYYY")}
                      </Typography>
                      <Typography variant="body1">
                        {row.observaciones}
                      </Typography>
                      <Typography variant="caption">
                        Usuario: {row.usuario}
                      </Typography>
                      <br />
                      <Typography variant="caption">
                        Monto a pagar: ${row.monto ? row.monto : 0}
                      </Typography>
                    </Box>
                  ))
              ) : (
                <Typography variant="body2">No hay observaciones.</Typography>
              )}
            </Box>

            <Box mt={2}>
              <form autoComplete="off">
                <TextField
                  fullWidth
                  label="Agregar Observaciones"
                  placeholder="Escribe aquí..."
                  name="observaciones"
                  multiline
                  variant="outlined"
                  value={almacenarobservaciones.observaciones || ""}
                  onChange={almacenar}
                />
              </form>
            </Box>

            <Box mt={2}>
              <form autoComplete="off">
                <TextField
                  fullWidth
                  required={datos.id_condicionpago === 21}
                  label="Monto que debe abonar el cliente"
                  placeholder="Ej: 1000.50"
                  name="monto"
                  variant="outlined"
                  value={almacenarobservaciones.monto || ""}
                  onChange={(e) => {
                    const valor = e.target.value;

                    // Permitir solo números, punto y coma
                    const regex = /^[0-9.,]*$/;
                    if (regex.test(valor)) {
                      almacenar({ target: { name: "monto", value: valor } });
                    }
                  }}
                  //icono $
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                    inputMode: "decimal",
                  }}
                  helperText={
                    almacenarobservaciones.monto &&
                      !isValidMonto(almacenarobservaciones.monto)
                      ? "Monto no válido. Use punto o coma como separador decimal."
                      : ""
                  }
                  error={
                    almacenarobservaciones.monto &&
                    !isValidMonto(almacenarobservaciones.monto)
                  }
                />
              </form>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      <DialogActions>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="space-between"
          alignItemns="center"
          style={{ padding: 30 }}
        >
          <Grid item>
            <Button variant="contained" color="error" onClick={handleClose}>
              Volver
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleGuardarObservacion}
              disabled={disBtn}
            >
              Grabar comentario
            </Button>
          </Grid>
          <Grid item>
            {datos.id_estado === 19 ? (
              datos.id_condicionpago === 2 || datos.mantiene_precio === 1 ? (
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#288d1f", color: "#fff" }}
                  onClick={handleAbrirModal}
                >
                  Aprobar
                </Button>
              ) : (
                <Button
                  // disabled={!existeMonto}
                  variant="contained"
                  style={{ backgroundColor: "#288d1f", color: "#fff" }}
                  onClick={handleCambiarEstado}
                >
                  Aprobar
                </Button>
              )
            ) : datos.id_estado === 21 ? (
              <Button
                variant="contained"
                style={{ backgroundColor: "#288d1f", color: "#fff" }}
                onClick={handlePendiente}
              >
                Pendiente
              </Button>
            ) : null}
          </Grid>
        </Grid>
      </DialogActions>

      <Modal open={openModal} onClose={handleCerrarModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            ¿El pedido fue abonado?
          </Typography>
          <Typography variant="body2" gutterBottom>
            Si el pedido fue abonado, se mantendrá el precio al momento de la
            carga.
          </Typography>

          <Box display="flex" justifyContent="space-between" mt={2}>
            <Button
              variant="contained"
              color="success"
              onClick={(e) => handleMatienePrecioAprobar(e)} // Pedido abonado, mantener precio
            >
              Pedido Abonado
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={(e) => handleNoMantieneyAprobar(e)} // Pedido no abonado, no mantener precio
            >
              Pedido No Abonado
            </Button>
          </Box>
        </Box>
      </Modal>

      {notificacion && notificacion.open && (
        <Notify
          mensaje={notificacion.mensaje}
          open={notificacion.open}
          color={notificacion.color}
          handleClose={handleClose}
          severity={notificacion.severity}
        />
      )}
    </Dialog>
  );
}
//------------- FECHA ACTUAL ---------------------//
// OBTENER FECHA ACTUAL
//const date = moment().format("YYYY-MM-DD HH:mm:ss");
// console.log("datos", datos);
// console.log("FECHA DE HOY", date);

// useEffect(() => {
//     switch (datos.id_estado) {
//         case 19:
//             setdisbtn(false)
//             setDisbtnAprobar(false)
//             break;
//         case 21:
//             setdisbtn(false)
//             setDisbtnAprobar(true)
//             break;

//         default:
//             break;
//     }
// }, [datos.id_estado]);

// console.log("datos", datos);